import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {RootState, store} from '../store';
// import {Role, User, Organizations} from 'src/apis/autoGenerate';
// import {userServiceDetail, orgServiceFind} from 'src/apis';
import {Role} from 'src/apis/autoGenerate/types/role';
import {User} from 'src/apis/autoGenerate/types/user';
import {userServiceDetail, orgServiceFind} from 'src/apis/autoGenerate/services';

export enum ApiFetchStatus {
  loading,
  idle,
  failed,
}

export interface AccountState {
  userId: string;
  userDetail: User | undefined;
  jwtToken: string;
  role: Role | undefined;
  organization?: {id: string; name: string};
}

const initialState: AccountState = {
  userId: '',
  jwtToken: '',
  role: undefined,
  userDetail: undefined,
  organization: undefined,
};

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setJwtToken: (state, action: PayloadAction<string>) => {
      state.jwtToken = action.payload;
    },
    setRole: (state, action: PayloadAction<Role>) => {
      state.role = action.payload;
    },
    setUserDetail: (state, action: PayloadAction<User>) => {
      state.userDetail = action.payload;
    },
    setOrganization: (state, action: PayloadAction<{id: string; name: string}>) => {
      state.organization = action.payload;
    },
  },
});

export const {setUserId, setJwtToken, setRole, setUserDetail, setOrganization} =
  accountSlice.actions;
export const selectAccount = (state: RootState) => state.account;

export function getUserDetails(userId: string) {
  const state = store.getState();
  const token = state.account.jwtToken;

  if (!token) {
    console.error('Error: Missing authentication token.');
    return;
  }

  // Get user details
  userServiceDetail(userId, {
    headers: {Authorization: `Bearer ${token}`},
  }).then(res => {
    // Only store the data, not the entire response
    const userDetail = res.data;
    store.dispatch(setUserDetail(userDetail));

    // Get user's organizations
    orgServiceFind(userId, {
      headers: {Authorization: `Bearer ${token}`},
    }).then(orgRes => {
      // Only store the data, not the entire response
      const organizations = orgRes.data;
      store.dispatch(
        setUserDetail({
          ...store.getState().account.userDetail,
          organizations: organizations.organizations,
        })
      );
    });
  });
}

export default accountSlice.reducer;
